// 계정·동기화 API 클라이언트(브랜드 빌드 전용). 토큰은 메모리(access) + localStorage(refresh, 이 기기).
// 401이면 refresh로 한 번 갱신 후 재시도. 일기·사람 등 민감 데이터는 여기로 보내지 않는다(금고 로컬).
const BASE = '/api/v1'
let accessToken: string | null = null
let refreshToken: string | null = null
try { refreshToken = localStorage.getItem('mp-rt') } catch { /* ignore */ }

export function setTokens(at: string | null, rt?: string | null) {
  accessToken = at
  if (rt !== undefined) {
    refreshToken = rt
    try { rt ? localStorage.setItem('mp-rt', rt) : localStorage.removeItem('mp-rt') } catch { /* ignore */ }
  }
}
export function hasSession() { return !!refreshToken }

async function raw(method: string, path: string, body?: unknown, auth = true): Promise<Response> {
  const headers: Record<string, string> = { 'content-type': 'application/json' }
  if (auth && accessToken) headers.authorization = `Bearer ${accessToken}`
  return fetch(BASE + path, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) })
}

export interface ApiError extends Error { code?: string; status?: number }

export async function api<T = any>(method: string, path: string, body?: unknown, auth = true): Promise<T> {
  let res = await raw(method, path, body, auth)
  if (res.status === 401 && auth && refreshToken) {
    const r = await raw('POST', '/auth/refresh', { refresh_token: refreshToken }, false)
    if (r.ok) { accessToken = (await r.json()).access_token; res = await raw(method, path, body, auth) }
    else setTokens(null, null)
  }
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const e: ApiError = Object.assign(new Error(data?.error?.message || `HTTP ${res.status}`), { code: data?.error?.code, status: res.status })
    throw e
  }
  return data as T
}
